// list of ingredients filters
export const ingredients = [
  {
    cat: 'Ingredients',
    key: 'Chicken',
    display: 'Chicken'
  },
  {
    cat: 'Ingredients',
    key: 'Pork',
    display: 'Pork'
  },
  {
    cat: 'Ingredients',
    key: 'Beef',
    display: 'Beef'
  },
  {
    cat: 'Ingredients',
    key: 'Fish',
    display: 'Fish'
  },
  {
    cat: 'Ingredients',
    key: 'Shellfish',
    display: 'Shellfish'
  },
  {
    cat: 'Ingredients',
    key: 'Pasta-and-Noodles',
    display: 'Pasta and Noodles'
  },
  {
    cat: 'Ingredients',
    key: 'Bread',
    display: 'Bread'
  },
  {
    cat: 'Ingredients',
    key: 'Broth',
    display: 'Broth'
  },
  {
    cat: 'Ingredients',
    key: 'Rice',
    display: 'Rice'
  },
  {
    cat: 'Ingredients',
    key: 'Other-Seafood',
    display: 'Other Seafood'
  },
  {
    cat: 'Ingredients',
    key: 'Other-Poultry',
    display: 'Other Poultry'
  },
  {
    cat: 'Ingredients',
    key: 'Other-Red-Meat',
    display: 'Other Red Meat'
  }
]